import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { NavMenu } from './nav/NavMenu';
import { NavbarHorizontal } from './nav/NavbarHorizontal';
import { Footer } from './Footer';

export class Layout extends Component {
    displayName = Layout.name

    constructor(props) {
        super(props);
        this.state = {
            isMenuOpen: false,
            isDropdownExtended: false,
        };

        this.toggleMenuHandler = this.toggleMenuHandler.bind(this);
        this.toggleDropdownExtendedHandler = this.toggleDropdownExtendedHandler.bind(this);
    }

    toggleMenuHandler() {
        const { isMenuOpen } = this.state;

        this.setState({
            isMenuOpen: !isMenuOpen
        });
    }

    toggleDropdownExtendedHandler() {
        const { isDropdownExtended } = this.state;

        this.setState({
            isDropdownExtended: !isDropdownExtended
        });
    }

    render() {
        const { isMenuOpen, isDropdownExtended } = this.state;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col>
                            <NavbarHorizontal
                                selectedComponent={this.state.selectedComponent}
                                isMenuOpen={isMenuOpen}
                                toggleMenuHandler={() => this.toggleMenuHandler()}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <NavMenu
                                isMenuOpen={isMenuOpen}
                                isDropdownExtended={isDropdownExtended}
                                toggleMenuHandler={() => this.toggleMenuHandler()}
                                toggleDropdownExtendedHandler={() => this.toggleDropdownExtendedHandler()}
                            />
                            <div className={`layout-content ${isMenuOpen ? "menu-open" : ""}`}>
                                {this.props.children}
                                <Footer />
                            </div>
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}
